
import { defineComponent, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useContent } from "../../composables/useContent";
import { getHeaderData } from "@/components/SEO/helpers";
import { useHead } from "@vueuse/head";
import { GENERAL_FEEDBACK_URL } from "@/constants/feedback";
import { SUPPORT_US_URL } from "@/constants/support";
import RenderContent from "@/components/RenderContent/RenderContent.vue";
import GalleryCard from "@/components/Gallery/GalleryCard.vue";
import { GalleryProps } from "../../composables/types";

export default defineComponent({
  name: "CollectionPage",
  components: {
    RenderContent,
    GalleryCard,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { load, result } = useContent();

    const collection = computed(() =>
      result.value?.id === "collections" ? result.value : undefined
    );

    const seo = computed(() => collection.value?.seo);

    const galleries = computed(() => collection.value?.galleries?.items);

    const sortedGalleries = computed(() => {
      return galleries.value
        ? galleries.value.slice().sort((a, b) => {
            const getRank = (item: GalleryProps) =>
              item.comingSoon ? 2 : item.featured ? 0 : 1;
            return getRank(a) - getRank(b);
          })
        : [];
    });

    const panels = computed(
      () => collection.value?.collectionContentCollection?.items
    );

    const headerData = computed(() =>
      getHeaderData(seo.value, { url: window.location.href })
    );

    onMounted(async () => {
      await load({ contentType: "collections", slug: route.params?.slug });
      if (result.value) {
        // If no data is returned other than the page ids, page is not found so redirect to home
        Object.keys(result.value).length === 2
          ? router.push({ path: "/" })
          : null;
      }
    });

    useHead({
      title: computed(() => headerData.value?.title || "Art Mindfully"),
      meta: computed(() => headerData.value?.meta || []),
      link: computed(() => headerData.value?.link || []),
    });

    return {
      id: route.params.slug,
      collection,
      GENERAL_FEEDBACK_URL,
      SUPPORT_US_URL,
      panels,
      sortedGalleries,
    };
  },
});
